import { IAdaptorService } from './../../../base/shared/syncfusion/adaptor-service.interface';
import { ToastService } from '../../../base/services/toast.service';
import {
  ServiceStatusClient,
  StatusServiceDTO,
  CreateStatusServiceDTO,
  UpdateStatusServiceDTO,
  FilterDTO,
  SortDirection,
  ServiceStatusLevel
} from '../../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ErrorType } from 'src/app/core/routing/error-types';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';

@Injectable()
export class ServicesAdministrationService extends ShowInactiveService implements IAdaptorService {

  constructor(
    private serviceStatusClient: ServiceStatusClient,
    private toastService: ToastService,
  ) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    return this.serviceStatusClient.getAll()
      .pipe(
        map((services: StatusServiceDTO[]) => {
          const items = services ?? [];
          return {
            items: items,
            totalNumberOfItems: items.length
          } as IPagedItems;
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public addRecord(data: any): Observable<StatusServiceDTO> {
    const dto = new CreateStatusServiceDTO({
      name: data.name,
      description: data.description,
      baseStatus: Number(data.baseStatus) as ServiceStatusLevel,
    });
    return this.serviceStatusClient.createServiceStatus(dto)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.services.messages.add-title', 'i18n.domain.services.messages.add-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public updateRecord(data: any): Observable<StatusServiceDTO> {
    const dto = new UpdateStatusServiceDTO({
      id: data.id,
      name: data.name,
      description: data.description,
      baseStatus: Number(data.baseStatus) as ServiceStatusLevel,
    });
    return this.serviceStatusClient.updateServiceStatus(dto)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.services.messages.update-title', 'i18n.domain.services.messages.update-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public deleteRecord(id: number): Observable<any> {
    return this.serviceStatusClient.deleteServiceStatus(id)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.services.messages.delete-title', 'i18n.domain.services.messages.delete-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
}
